module.exports = __webpack_public_path__ + "static/NOI6-d9a80acf20dcc77860e3e0632f814f10.png";